<template>
  <div>
    <Spinner v-if="isLoading" />

    <div class="notification is-info" v-if="hasNoHuntAreas">No hunt areas found.</div>

    <div class="notification is-danger" v-if="loadError">{{ loadError }}</div>

    <HuntAreasList
      :memberUserId="user.id"
      :huntAreas="huntAreas"
      :usersCacheStorePath="usersCacheStorePath"
      :huntAreasCacheStorePath="huntAreasCacheStorePath"
      v-if="huntAreasLoaded"
      @hunt-area-selected="huntAreaSelected($event)"/>
  </div>
</template>

<script>
import Spinner from "@/components/utils/Spinner";
import HuntAreasList from "@/modules/huntareas/HuntAreasList";

import {
  LOAD_HUNT_AREAS,
  GET_USER,
  IS_LOADING_HUNT_AREAS,
  GET_HUNT_AREAS,
  HAS_EMPTY_HUNT_AREAS_LOAD_RESULT,
  GET_HUNT_AREAS_LOAD_ERROR
} from "./userStore";

import {
  SET_HUNT_AREA
} from "@/modules/huntareas/huntAreaStore.js"

export default {
  name: "UserHuntAreasTab",

  components: {
    HuntAreasList,
    Spinner
  },

  props: {
    userStorePath: {
      type: String,
      required: true
    },

    selectedHuntAreaStorePath: {
      type: String,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    },

    huntAreasCacheStorePath: {
      type: String,
      required: true
    }
  },

  mounted() {
    const loadHuntAreasAction = `${this.userStorePath}/${LOAD_HUNT_AREAS}`;
    this.$store.dispatch(loadHuntAreasAction);
  },

  computed: {
    huntAreasLoaded() {
      return this.user !== null && this.huntAreas !== null;
    },

    user() {
      const getUser = `${this.userStorePath}/${GET_USER}`;
      return this.$store.getters[getUser];
    },

    isLoading() {
      const isLoadingHuntAreas = `${this.userStorePath}/${IS_LOADING_HUNT_AREAS}`;
      return this.$store.getters[isLoadingHuntAreas];
    },

    hasNoHuntAreas() {
      const hasEmptyHuntAreasLoadResult = `${this.userStorePath}/${HAS_EMPTY_HUNT_AREAS_LOAD_RESULT}`;
      return this.$store.getters[hasEmptyHuntAreasLoadResult];
    },

    huntAreas() {
      const getHuntAreas = `${this.userStorePath}/${GET_HUNT_AREAS}`;
      return this.$store.getters[getHuntAreas];
    },

    loadError() {
      const getHuntAreasLoadError = `${this.userStorePath}/${GET_HUNT_AREAS_LOAD_ERROR}`;
      return this.$store.getters[getHuntAreasLoadError];
    }
  },

  methods: {
    huntAreaSelected(huntArea) {
      const setHuntAreaAction = `${this.selectedHuntAreaStorePath}/${SET_HUNT_AREA}`;
      this.$store.dispatch(setHuntAreaAction, { huntArea });

      const huntAreaId = huntArea.id;
      this.$router.push({ name: 'userDetailsHuntArea', params: { huntAreaId }, query: this.$route.query });
    }
  }
};
</script>
